import { ReactLenis } from "lenis/dist/lenis-react";
import {
  motion,
  useMotionTemplate,
  useScroll,
  useTransform,
} from "framer-motion";
import { useRef } from "react";

export const SmoothScrollHero = () => {
  return (
    <div className="bg-cream" style={{ marginBottom: "-300px" }}>
      <ReactLenis
        root
        options={{
          lerp: 0.05,
          // infinite: true,
          syncTouch: true,
        }}
      >
        <Hero />
      </ReactLenis>
    </div>
  );
};

const SECTION_HEIGHT = {
  mobile: 500,  // Pour les écrans mobiles
  desktop: 800  // Valeur actuelle
};

const Hero = () => {
  return (
    <div
      style={{ height: `calc(${window.innerWidth < 768 ? SECTION_HEIGHT.mobile : SECTION_HEIGHT.desktop}px + 50vh)` }}
      className="relative w-11/12 flex flex-col justify-center items-center mx-auto"
    >
      <CenterImage />

      <ParallaxImages />

      <div className="absolute bottom-0 left-0 right-0  bg-gradient-to-b from-chalk-beige/0 to-chalk-beige/0" />
    </div>
  );
};

const CenterImage = () => {
  const { scrollY } = useScroll();

  const clip1 = useTransform(scrollY, [0, 1500], [25, 0]);
  const clip2 = useTransform(scrollY, [0, 1500], [75, 100]);

  const clipPath = useMotionTemplate`polygon(${clip1}% ${clip1}%, ${clip2}% ${clip1}%, ${clip2}% ${clip2}%, ${clip1}% ${clip2}%)`;

  const backgroundSize = useTransform(
    scrollY,
    [0, SECTION_HEIGHT + 500],
    ["170%", "100%"]
  );
  const opacity = useTransform(
    scrollY,
    [SECTION_HEIGHT, SECTION_HEIGHT + 500],
    [1, 0]
  );

  return (
    <motion.div
      className="sticky top-0 h-1/5 w-full"
      style={{
        clipPath,
        backgroundSize,
        opacity,
        backgroundImage:
          "url()",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    />
  );
};

const ParallaxImages = () => {
  return (
    <div className="mx-7 w-full px-4 flex flex-col items-center">
      <ParallaxImg
        src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fi.pinimg.com%2Foriginals%2Fba%2F2c%2F40%2Fba2c403913ad9c5bb3597eb36200f749.png&f=1&nofb=1&ipt=3b0384f0bea6dfb458a9bb517d0ea7bbb7f15a6a02c3bc3ef571645fd1afc1f7&ipo=images"
        alt="Long chair"
        start={100}
        end={-200}
        className="md:w-1/3 sm:w-1/4 absolute left-0"
      />
      <ParallaxImg
        src="https://dedece.com/wp-content/uploads/2020/05/Knoll__Barcelona-Chair-2-1-912x868.png"
        alt="knoll barcelona chair"
        start={200}
        end={-250}
        className="ml-auto md:w-1/3 sm:w-1/4 right-0"
      />
      <ParallaxImg
        src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fik.imagekit.io%2Fidxr0pznf%2Fapp%2Fuploads%2F2022%2F12%2FUp-2000-BB-Italia-poltrona-salotto-Peverelli-1.png&f=1&nofb=1&ipt=98a018c9cee1d04e68709b099e3d5b66c78d7b96042651322aa6dfcfe326432d&ipo=images"
        alt="BB Italia"
        start={100}
        end={-150}
        className="ml-auto md:w-1/3 sm:w-1/4 max-w-100"
      />
      <ParallaxImg
        src="/assets/images/smoothscroll/knoll_wassily.png"
        alt="Knoll Wassily"
        start={200} // Valeur plus négative pour le placer plus haut
        end={-100}   // Ajuster selon l'effet désiré
        className="ml-24 md:w-1/4 sm:w-1/5 z-0 absolute" // Même margin-left que USM Haller, mais largeur plus petite
      />
      <ParallaxImg
        src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fus.usm.com%2Fcdn%2Fshop%2Ffiles%2FQS_E2_36_olive_973f68ab-329f-4aa1-a011-938781153635_2048x2048.png%3Fv%3D1720784365&f=1&nofb=1&ipt=bfff4822e0ddc21ea71405c3995454394dfc3c3282b051bffce66066c02330e7&ipo=images"
        alt="USM Haller"
        start={200}
        end={-50}
        className="ml-24 md:w-2/5 sm:w-2/6 z-0 absolute"
      />
      <ParallaxImg
        src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fdedece.com%2Fwp-content%2Fuploads%2F2020%2F05%2FTulip-Chair-Saarinen-1-684x868.png&f=1&nofb=1&ipt=29d03e219552600c629a83c7cf67ba0d1e66588516601e5c7da0bb3bb744113b&ipo=images"
        alt="Saarinen Tulip Chair"
        start={-500}
        end={-700}
        className="md:w-1/3 mr-auto max-w-80"
      />
    </div>
  );
};

const ParallaxImg = ({ className, alt, src, start, end }) => {
  const ref = useRef(null);

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: [`${start}px end`, `end ${end * -1}px`],
  });

  const opacity = useTransform(scrollYProgress, [0.75, 1], [1, 0]);
  const scale = useTransform(scrollYProgress, [0.75, 1], [1, 0.85]);

  const y = useTransform(scrollYProgress, [0, 1], [start, end]);
  const transform = useMotionTemplate`translateY(${y}px) scale(${scale})`;

  return (
    <motion.img
      src={src}
      alt={alt}
      className={className}
      ref={ref}
      style={{ transform, opacity }}
    />
  );
};